import { render } from "./CreatePRAttachment.vue?vue&type=template&id=e5a9eace"
import script from "./CreatePRAttachment.vue?vue&type=script&lang=js"
export * from "./CreatePRAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__